export const config = {
    name: 'revenueForecastPending',
    searchFields: [
        {
            name: '预测月份',
            value: 'periodMonth',
            type: 'date',
            timeType: 'month',
            format: 'yyyy-MM',
            valueFormat: 'yyyy-MM',
            isFixed: true,
            span: 3
        },
        {
            name: '收入预测版本',
            value: 'forecastVersionCode',
            type: 'select',
            isFixed: true,
            span: 3,
            fieldName: 'forecastVersionCode'
        },
        {
            name: '分公司',
            value: 'companyName',
            type: 'advance',
            isFixed: true,
            span: 3,
            advanceConfig: [
                { 'prop': 'name', 'value': '分公司名称' },
                { 'prop': 'code', 'value': '分公司编码' }
            ],
            tableConfig: [
                { 'prop': 'code', 'value': '分公司编码' },
                { 'prop': 'name', 'value': '分公司名称', 'displayName': 'name' }
            ],
            method: 'post',
            prefix: '/api-lcrm',
            advanceUrl: `/revenueForecastVersion/todo/condition`,
            cbParams: ['name#companyName', 'code#companyCode'],
            beforeRequest: (params) => {
                params.type = 'company';
                const input = params.name || params.code || '';
                params.keyWord = input;
                delete params.name;
                delete params.code;
                return params;
            }
        },
        {
            name: '行业大类',
            value: 'industryCategoriesCode',
            type: 'select',
            isFixed: true,
            span: 3,
            fieldName: 'industryCategoriesCode'
        },
        {
            name: '待办状态',
            value: 'statusCode',
            type: 'select',
            isFixed: true,
            multiple: false,
            span: 3,
            optionNum: 'LCRM_TODO_STATUS'
        },
        {
            name: '待办人',
            value: 'ownerName',
            type: 'advance',
            isFixed: true,
            span: 3,
            advanceConfig: [
                { 'prop': 'name', 'value': '姓名' },
                { 'prop': 'code', 'value': 'MIP账号' }
            ],
            tableConfig: [
                { 'prop': 'code', 'value': 'MIP账号' },
                { 'prop': 'name', 'value': '姓名', 'displayName': 'name' }
            ],
            method: 'post',
            prefix: '/api-lcrm',
            advanceUrl: `/revenueForecastVersion/todo/condition`,
            cbParams: ['name#ownerName', 'code#ownerCode'],
            beforeRequest: (params) => {
                params.type = 'owner';
                const input = params.name || params.code || '';
                params.keyWord = input;
                delete params.name;
                delete params.code;
                return params;
            }
        }
    ],
    selection: false,
    index: false,
    height: '500px',
    industryColumns: [
        {
            label: '行业名称',
            prop: 'industryName'
        },
        {
            label: '未启动',
            type: 'slot',
            prop: 'unStartedCount',
            sort: 'custom'
        },
        {
            label: '进行中',
            type: 'slot',
            prop: 'progressCount',
            sort: 'custom'
        },
        {
            label: '审批中',
            type: 'slot',
            prop: 'approvalCount',
            sort: 'custom'
        },
        {
            label: '驳回',
            type: 'slot',
            prop: 'rejectedCount',
            sort: 'custom'
        },
        {
            label: '撤回',
            type: 'slot',
            prop: 'withdrawnCount',
            sort: 'custom'
        },
        {
            label: '已完成',
            type: 'slot',
            prop: 'completedCount',
            sort: 'custom'
        },
        {
            label: '待办总数量',
            type: 'slot',
            prop: 'totalTodoCount',
            sort: 'custom'
        },
        {
            label: '完成率',
            prop: 'completionRate'
        }
    ],
    companyColumns: [
        {
            label: '分公司名称',
            prop: 'companyName'
        },
        {
            label: '未启动',
            type: 'slot',
            prop: 'unStartedCount',
            sort: 'custom'
        },
        {
            label: '进行中',
            type: 'slot',
            prop: 'progressCount',
            sort: 'custom'
        },
        {
            label: '审批中',
            type: 'slot',
            prop: 'approvalCount',
            sort: 'custom'
        },
        {
            label: '驳回',
            type: 'slot',
            prop: 'rejectedCount',
            sort: 'custom'
        },
        {
            label: '撤回',
            type: 'slot',
            prop: 'withdrawnCount',
            sort: 'custom'
        },
        {
            label: '已完成',
            type: 'slot',
            prop: 'completedCount',
            sort: 'custom'
        },
        {
            label: '待办总数量',
            type: 'slot',
            prop: 'totalTodoCount',
            sort: 'custom'
        },
        {
            label: '完成率',
            prop: 'completionRate'
        }
    ],
    personalColumns: [
        {
            label: '待办人',
            prop: 'ownerCode'
        },
        {
            label: '待办人名称',
            prop: 'ownerName'
        },
        {
            label: '未启动',
            type: 'slot',
            prop: 'unStartedCount',
            sort: 'custom'
        },
        {
            label: '进行中',
            type: 'slot',
            prop: 'progressCount',
            sort: 'custom'
        },
        {
            label: '审批中',
            type: 'slot',
            prop: 'approvalCount',
            sort: 'custom'
        },
        {
            label: '驳回',
            type: 'slot',
            prop: 'rejectedCount',
            sort: 'custom'
        },
        {
            label: '撤回',
            type: 'slot',
            prop: 'withdrawnCount',
            sort: 'custom'
        },
        {
            label: '已完成',
            type: 'slot',
            prop: 'completedCount',
            sort: 'custom'
        },
        {
            label: '待办总数量',
            type: 'slot',
            prop: 'totalTodoCount',
            sort: 'custom'
        },
        {
            label: '完成率',
            prop: 'completionRate'
        }
    ]
};
